import { render, staticRenderFns } from "./JoinMailing.vue?vue&type=template&id=ef74d5fe&"
import script from "./JoinMailing.vue?vue&type=script&lang=js&"
export * from "./JoinMailing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports